import noop from 'lodash';
import { useMemo } from 'react';

import { DocplannerServiceMapping, DocplannerServiceMappingQuery } from '@dreryk/egabinet-docplanner-frontend-api';

import {
   LazyLoadedDataConfigurationByCqrsQuery,
   useLazyLoadedDataConfigurationByCqrsQuery,
} from '@dreryk/drerykweb-main-frontend';
import {
   createDynamicColumnsWidth,
   HorizontalAlign,
   JustifyContent,
   TableColumnConfiguration,
   ValueRendererProps,
} from '@dreryk/react-components';

import { medicalServicesMappingsTranslationKeys } from '../../translations';

import { DocplannerServiceMappingRemove } from './docplannerServiceMappingRemove/DocplannerServiceMappingRemove';
import { PriceCell } from './PriceCell';

type MedicalServicesMappingTableColumnConfigurationOptions = {
   onMappingRemoveSuccess: VoidFunction;
};

export const useMedicalServicesMappingsTableColumnConfiguration = (
   options: MedicalServicesMappingTableColumnConfigurationOptions
): TableColumnConfiguration<DocplannerServiceMapping>[] => {
   const columnsWidth = useMemo(
      () =>
         createDynamicColumnsWidth({
            docplannerService: '50%',
            eGabinetService: '50%',
            price: '180px',
            options: '57px',
         }),
      []
   );
   return useMemo(
      () => [
         {
            name: 'docplannerService',
            label: medicalServicesMappingsTranslationKeys.docplannerService,
            accessor: (bean) => bean.docplannerService.externalName,
            width: columnsWidth.docplannerService,
            sortingDisabled: true,
         },
         {
            name: 'eGabinetService',
            label: medicalServicesMappingsTranslationKeys.receptionService,
            accessor: (bean) => bean.receptionService.name,
            width: columnsWidth.eGabinetService,
            sortingDisabled: true,
         },
         {
            name: 'price',
            label: medicalServicesMappingsTranslationKeys.receptionServicePrice,
            justifyContent: JustifyContent.END,
            textAlign: HorizontalAlign.RIGHT,
            accessor: (bean) => bean.receptionService.minPrice,

            renderer: ({ bean }: ValueRendererProps<DocplannerServiceMapping>) => {
               return <PriceCell min={bean.receptionService.minPrice} max={bean.receptionService.maxPrice} />;
            },
            width: columnsWidth.price,
            sortingDisabled: true,
         },
         {
            name: 'options',
            label: '',
            accessor: noop,
            justifyContent: JustifyContent.END,

            renderer: ({ bean }: ValueRendererProps<DocplannerServiceMapping>) => {
               return (
                  <DocplannerServiceMappingRemove
                     docplannerServiceName={bean.docplannerService.externalName}
                     mappingId={bean.id}
                     receptionServiceName={bean.receptionService.name}
                     onMappingRemoveSuccess={options.onMappingRemoveSuccess}
                  />
               );
            },
            width: columnsWidth.options,
            sortingDisabled: true,
         },
      ],
      [columnsWidth, options]
   );
};

export const useMedicalServicesLazyLoadedDataConfiguration = (): LazyLoadedDataConfigurationByCqrsQuery<DocplannerServiceMapping> => {
   return useLazyLoadedDataConfigurationByCqrsQuery(() => new DocplannerServiceMappingQuery());
};
